var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sw-grid-flex sw-grid-flex--dir-column" },
    [
      _c(
        "div",
        {
          staticClass:
            "sw-grid-flex sw-grid-flex--wrap sw-grid-flex--align-center"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.showAddNewResourceClass
            ? _c(
                "div",
                {
                  staticClass:
                    "sw-grid-flex\n                sw-grid-flex--wrap\n                sw-grid-flex__cell-1-1\n                sw--padding-vert-2\n                sw-grid-flex--align-center\n                sw--padding-hor-2"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sw-grid-flex__cell-1-3 sw-grid-flex--align-center sw-grid-flex"
                    },
                    [
                      _c("div", { staticClass: "sw-grid-flex__cell-1-2" }, [
                        _c("label", [_vm._v("Resource name")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newResourceClass.name,
                              expression: "newResourceClass.name"
                            }
                          ],
                          staticClass:
                            "sw--input-height__medium sw--font-size-14 sw--width-full",
                          attrs: {
                            type: "text",
                            placeholder: "Your new Resource name..."
                          },
                          domProps: { value: _vm.newResourceClass.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.newResourceClass,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "sw-grid-flex__cell-1-2 sw--padding-left-2"
                        },
                        [
                          _c("label", { staticClass: "sw--display-block" }, [
                            _vm._v(
                              _vm._s(
                                _vm.newResourceClass.newProductionFile.name
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newResourceClass.fileType,
                                  expression: "newResourceClass.fileType"
                                }
                              ],
                              staticClass:
                                "sw-select--not-round sw--width-half",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.newResourceClass,
                                    "fileType",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            _vm._l(
                              _vm.newResourceClass.newProductionFile.fields,
                              function(field) {
                                return _c(
                                  "option",
                                  { domProps: { value: field.value } },
                                  [_vm._v(_vm._s(field.name))]
                                )
                              }
                            ),
                            0
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sw-grid-flex__cell-1-3 sw-grid-flex--align-center sw-grid-flex sw-grid-flex--wrap"
                    },
                    _vm._l(
                      _vm.newResourceClass.newProductionMethod.fields,
                      function(field) {
                        return _c(
                          "div",
                          {
                            key: field.name,
                            staticClass: "sw-grid-flex__cell-1-3"
                          },
                          [
                            _c("label", [_vm._v(_vm._s(field.text))]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: field.value,
                                  expression: "field.value",
                                  modifiers: { number: true }
                                }
                              ],
                              staticClass: "sw--width-full",
                              domProps: { value: field.value },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    field,
                                    "value",
                                    _vm._n($event.target.value)
                                  )
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            })
                          ]
                        )
                      }
                    ),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sw-grid-flex__cell-1-3 sw-grid-flex--align-center sw-grid-flex sw-grid-flex--wrap sw-grid-flex--justify-center"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "sw-dms-button sw--margin-right-3",
                          on: {
                            click: function($event) {
                              _vm.showAddNewResourceClass = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.resourceClasses, function(resource, index) {
            return _c(
              "div",
              {
                key: "resource-" + resource.id,
                staticClass:
                  "sw-grid-flex\n                sw-grid-flex--wrap\n                sw-grid-flex__cell-1-1\n                sw--padding-vert-2\n                sw-grid-flex--align-center\n                sw--padding-hor-2",
                class: index % 2 ? "" : "sw-dms--bg-grey-96"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "sw-grid-flex__cell-1-3 sw-grid-flex--align-center sw-grid-flex"
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.resourceClassesSelected,
                          expression: "resourceClassesSelected"
                        }
                      ],
                      attrs: { type: "checkbox", disabled: !_vm.materialId },
                      domProps: {
                        value: resource.id,
                        checked: Array.isArray(_vm.resourceClassesSelected)
                          ? _vm._i(_vm.resourceClassesSelected, resource.id) >
                            -1
                          : _vm.resourceClassesSelected
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.resourceClassesSelected,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = resource.id,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.resourceClassesSelected = $$a.concat([
                                  $$v
                                ]))
                            } else {
                              $$i > -1 &&
                                (_vm.resourceClassesSelected = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.resourceClassesSelected = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "h6",
                      {
                        staticClass: "sw--padding-left-2 sw--margin-0",
                        class: !_vm.materialId ? "sw-dms--color-grey-46" : ""
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(resource.modelNumber) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "sw-grid-flex__cell-1-3" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.resourcePrinterMap[resource.id],
                          expression: "resourcePrinterMap[resource.id]"
                        }
                      ],
                      staticClass: "sw-select--not-round sw--width-full",
                      attrs: {
                        disabled: !_vm.resourceClassesSelected.includes(
                          resource.id
                        )
                      },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.resourcePrinterMap,
                            resource.id,
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(_vm.printers, function(printer) {
                      return _c(
                        "option",
                        {
                          key: "printer-" + printer.id,
                          domProps: { value: printer.id }
                        },
                        [_vm._v(_vm._s(printer.title) + "\n          ")]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sw-grid-flex__cell-1-3" }, [
                  _vm.resourcePrinterMap[resource.id]
                    ? _c(
                        "p",
                        { staticClass: "sw--margin-0 sw--padding-left-3" },
                        [
                          _c("span", { staticClass: "sw--font-weight-bold" }, [
                            _vm._v("Min:")
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.getPrinterById(
                                  _vm.resourcePrinterMap[resource.id]
                                ).xBoundMin
                              ) +
                              "x\n          " +
                              _vm._s(
                                _vm.getPrinterById(
                                  _vm.resourcePrinterMap[resource.id]
                                ).yBoundMin
                              ) +
                              "x\n          " +
                              _vm._s(
                                _vm.getPrinterById(
                                  _vm.resourcePrinterMap[resource.id]
                                ).zBoundMin
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resourcePrinterMap[resource.id]
                    ? _c(
                        "p",
                        { staticClass: "sw--margin-0 sw--padding-left-3" },
                        [
                          _c("span", { staticClass: "sw--font-weight-bold" }, [
                            _vm._v("Max:")
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.getPrinterById(
                                  _vm.resourcePrinterMap[resource.id]
                                ).xBoundMax
                              ) +
                              "x\n          " +
                              _vm._s(
                                _vm.getPrinterById(
                                  _vm.resourcePrinterMap[resource.id]
                                ).yBoundMax
                              ) +
                              "x\n          " +
                              _vm._s(
                                _vm.getPrinterById(
                                  _vm.resourcePrinterMap[resource.id]
                                ).zBoundMax
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("bottom-banner", {
        attrs: {
          "missing-info": !_vm.materialId ? ["Basic Information"] : [],
          "show-saved-message": _vm.showSavedMessage,
          "show-add-new-btn": !_vm.showAddNewResourceClass
        },
        on: { saved: _vm.saveResourcePrinter, "add-new": _vm.showAddNew }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "sw-grid-flex\n                sw-grid-flex--wrap\n                sw-grid-flex__cell-1-1\n                sw--padding-vert-2\n                sw-grid-flex--align-center\n                sw--padding-hor-2"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "sw-grid-flex__cell-1-3 sw-grid-flex--align-center sw-grid-flex"
          },
          [_c("h6", [_vm._v("Resource Class")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "sw-grid-flex__cell-2-3 sw-grid-flex--align-center sw-grid-flex"
          },
          [_c("h6", [_vm._v("Production Method")])]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }